import { render, staticRenderFns } from "./purchasingOrder.vue?vue&type=template&id=1b4dd723&scoped=true"
import script from "./purchasingOrder.vue?vue&type=script&lang=js"
export * from "./purchasingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4dd723",
  null
  
)

export default component.exports